export default "__VITE_ASSET__ICAPwRUl__"